import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/CollectionReport";

/**
 * Tahsilat raporu özet kartları ve yaşlandırma dilimleri.
 * StartDate/EndDate yalnızca gerçekleşmiş tahsilat toplamını etkiler.
 * OverdueStartDate/OverdueEndDate vadesi geçen açık alacakları,
 * UpcomingStartDate/UpcomingEndDate gelecek vadeli açık alacakları etkiler.
 * Vade aralıkları gönderilmezse tüm geçmiş ve gelecek açık ödemeler korunur.
 * PaymentType özet çağrısında genel kapsamı daraltmaz.
 * @param {{ params?: object, query?: {
 *   StartDate?: string,
 *   EndDate?: string,
 *   OverdueStartDate?: string,
 *   OverdueEndDate?: string,
 *   UpcomingStartDate?: string,
 *   UpcomingEndDate?: string,
 *   CustomerId?: string,
 *   RegionId?: string,
 *   EmployeeId?: string,
 *   PaymentType?: 1 | 2 | 3 | 4,
 * }}} options
 */
export const GetSummary = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetSummary`, options);

/**
 * Tip bazlı açık alacak / tahsilat listesi (sayfalanmış).
 * Type: Unplanned=1, Planned=2, Overdue=3, Total=4
 * PaymentType: Cash=1, NoInstallmentCreditCard=2,
 * WithInstallmentCreditCard=3, PromissorySale=4
 * @param {{ params?: object, query?: {
 *   StartDate?: string,
 *   EndDate?: string,
 *   OverdueStartDate?: string,
 *   OverdueEndDate?: string,
 *   UpcomingStartDate?: string,
 *   UpcomingEndDate?: string,
 *   CustomerId?: string,
 *   RegionId?: string,
 *   EmployeeId?: string,
 *   Type: 1 | 2 | 3 | 4 | 'Total',
 *   PaymentType?: 1 | 2 | 3 | 4,
 *   Page?: number,
 *   Limit?: number,
 * }}} options
 */
export const GetDetails = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetDetails`, options);

export default {
  GetSummary,
  GetDetails,
};
